import { type PortalLocation } from 'core/types'
import { BirthdayToAgeInYearsAndMonths } from 'core/Utilities'

interface BasicChild {
  firstName: string | null
  lastName: string
  unborn: boolean
  dateOfBirth: Date | null
  hasPendingDuplicate: boolean
  imageKey: string | null
}

export const childName = (child: BasicChild): string => {
  let firstName: string
  if (child.unborn) {
    firstName = '(Unborn)'
  } else if (child.firstName != null && child.firstName !== '') {
    firstName = child.firstName
  } else {
    firstName = '(Unnamed)'
  }
  if (child.hasPendingDuplicate) {
    return `Duplicate Pending Child (${firstName} ${child.lastName})`
  } else {
    return `${firstName} ${child.lastName}`
  }
}

export const childAge = (child: BasicChild): string => {
  if (child.unborn) {
    return '(Unborn)'
  } else if (child.dateOfBirth != null) {
    return BirthdayToAgeInYearsAndMonths(child.dateOfBirth, false)
  } else {
    return ''
  }
}

export const getDayOfWeek = (): string => {
  const dayOfWeekNumber = new Date().getDay()
  if (dayOfWeekNumber === 0) {
    return 'Sunday'
  } else if (dayOfWeekNumber === 1) {
    return 'Monday'
  } else if (dayOfWeekNumber === 2) {
    return 'Tuesday'
  } else if (dayOfWeekNumber === 3) {
    return 'Wednesday'
  } else if (dayOfWeekNumber === 4) {
    return 'Thursday'
  } else if (dayOfWeekNumber === 5) {
    return 'Friday'
  } else if (dayOfWeekNumber === 6) {
    return 'Saturday'
  }

  return ''
}

export const parseAddress = (fullAddress: string): PortalLocation => {
  const parts = fullAddress.split(',')
  if (fullAddress !== '' && parts.length > 3) {
    const address = parts[0].trim()
    const city = parts[1].trim()
    const stateZip = parts[2].trim()
    // this will break if its canada, i really think we need to store the loc as the object
    const lastSpace = stateZip.lastIndexOf(' ')
    const state = stateZip.substring(0, lastSpace)
    const zipCode = stateZip.substring(lastSpace + 1, stateZip.length)
    return {
      address,
      apartment: '',
      city,
      state,
      zipCode
    }
  } else {
    return {
      address: '',
      apartment: '',
      city: '',
      state: '',
      zipCode: ''
    }
  }
}
